import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {ISavedSearchResponse} from '../../api/types/savedsearch.types';
import {ReactComponent as TrueLawAIIcon} from '../../assets/images/export-truelaw-ai.svg';
import {ReactComponent as InfoIcon} from '../../assets/images/info-icon.svg';
import {
  useDocumentList,
  useDocumentViewerListId,
  useGetNavigationMasterListId,
} from '../../hooks/document/useDocument';
import {useRedirectReport} from '../../hooks/reporting/useReporting';
import {
  useGetCompletedSavedSearchId,
  useGetSearchCount,
  useRunBackgroundSearchQueue,
} from '../../hooks/search/useSearch';
import {
  setDocListBackNavigation,
  setDocListId,
} from '../../redux/slice/docListSlice';
import {
  storeDocumentListMasterId,
  storeSourceTypeCode,
} from '../../redux/slice/docViewSlice';
import {RootState} from '../../redux/store';
import {
  ReportActionMenuOptionTypes,
  RoleId,
  SourceTypeCode,
  SourceTypeContextCode,
  ToastType,
} from '../../shared/constants';
import {
  DocActionMenuItem,
  ExtendedTreeItemProps,
} from '../../shared/interfaces';
import ActionMenuWrapper from '../action-menu/action-menu-wrapper/ActionMenuWrapper';
import ArrButton from '../common/arr-button/ArrButton';
import ArrDocMaxLimitWarning from '../common/arr-doc-max-limit-warning/ArrDocMaxLimitWarning';
import ArrLoadingSpinner from '../common/arr-loading-spinner/ArrLoadingSpinner';
import {CustomMenuItem} from '../common/arr-menu/ArrMenu';
import ArrSplitPanel from '../common/arr-split-panel/ArrSplitPanel';
import ArrToastNotification from '../common/arr-toast-notification/ArrToastNotification';
import ArrTooltipWrapper from '../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import ExportTrueLawModal from './export-trulelaw-ai/ExportTrueLawModal';
import SavedSearchDataGrid from './saved-search-data-grid/SavedSearchDataGrid';
import SavedSearchTree from './saved-search-tree/SavedSearchTree';
import './ViewSavedSearch.scss';
import {setReportDetails} from '../../redux/slice/comExplorerSlice';
import ArrModal from '../common/arr-modal/ArrModal';
import {TreeViewBaseItem} from '@mui/x-tree-view';
import {UserRights} from '../../api/types/user.type';
import ArrDataGrid from '../common/arr-data-grid/ArrDataGrid';
import ArrBanner from '../common/arr-banner/ArrBanner';
import {DEFAULT_ROW_HEIGHT} from '../common/lazy-load-data-grid/constant';
import {ReactComponent as CompleteIcon} from '../../assets/images/complete-icon.svg';
import {ReactComponent as ExportIcon} from '../../assets/images/export.svg';
import {IRunBackgroundSearchQueueRequest} from '../../api/types/searchType.type';
import {useResolveNestedSavedSearch} from '../../hooks/saved-search/useSavedSearch';
import {NestedSearchResponse} from '../../api/types/savedSearch.type';
import {nestedColumns} from '../../api/types/nestedsearch.types';
const mockNestedSearchData = {
  data: {
    nestedSavedSearchesCount: 2,

    nestedSavedSearches: [
      {
        id: 427,

        name: 'Base Search 1 - Responsive Docs',

        searchGroup: 'Base Searches',

        lastCompleteTime: '2025-12-08T14:21:24.34',
      },
      {
        id: 1478,

        name: 'Base Search 2 - Privileged Docs',

        searchGroup: 'Base Searches',

        lastCompleteTime: '2025-12-08T14:21:24.34',
      },
      {
        id: 1422,

        name: 'Base Search 2 - New Docs',

        searchGroup: 'Deafult Searches',

        lastCompleteTime: '2025-12-08T14:21:24.34',
      },
      {
        id: 1486,

        name: 'Base Search 2 - test Docs',

        searchGroup: 'Nested Searches',

        lastCompleteTime: '2025-12-08T14:21:24.34',
      },
    ],
  },
};

export const SAVED_SEARCH_ACTION_MENU: DocActionMenuItem[] = [
  {
    id: 'View',
    name: 'View',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager, RoleId.Reviewer],
    subItems: [
      {
        id: 'ViewInDocView',
        name: 'ViewInDocView',
        Roles: [
          RoleId.ProjectAdministrator,
          RoleId.ReviewManager,
          RoleId.Reviewer,
        ],
      },
      {
        id: 'ViewInDocViewInNewTab',
        name: 'ViewInDocViewInNewTab',
        Roles: [
          RoleId.ProjectAdministrator,
          RoleId.ReviewManager,
          RoleId.Reviewer,
        ],
      },
      {
        id: 'ViewInDocList',
        name: 'ViewInDocList',
        Roles: [
          RoleId.ProjectAdministrator,
          RoleId.ReviewManager,
          RoleId.Reviewer,
        ],
      },
    ],
  },
  {
    id: 'BulkTag',
    name: 'BulkTag',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager, RoleId.Reviewer],
  },
  {
    id: 'BulkFolder',
    name: 'BulkFolder',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager, RoleId.Reviewer],
  },
  {
    id: 'BulkRelease',
    name: 'BulkRelease',
    Roles: [RoleId.ProjectAdministrator],
  },
  {
    id: 'SearchTermReport',
    name: 'SearchTermReport',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager],
  },
  {
    id: 'ExportData',
    name: 'ExportData',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager, RoleId.Reviewer],
  },
  {
    id: 'BulkAssign',
    name: 'BulkAssign',
    Roles: [RoleId.ReviewManager],
  },
  {
    id: 'QuickBatch',
    name: 'QuickBatch',
    Roles: [RoleId.ReviewManager],
  },
  {
    id: 'TallyReport',
    name: 'TallyReport',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager],
  },
  {
    id: 'SeeConcepts',
    name: 'SeeConcepts',
    Roles: [RoleId.ProjectAdministrator, RoleId.ReviewManager],
  },
  {
    id: 'ExportTrueLawAI',
    name: 'ExportTrueLawAI',
    Roles: [
      RoleId.ProjectAdministrator,
      RoleId.ReviewManager,
      RoleId.DomainAdministrator,
      RoleId.SystemAdministrator,
    ],
  },
];

const canExportToTrueLaw = (rights: UserRights): boolean => {
  return !rights?.canExportToTrueLaw;
};

const isActionDisabled = (
  actionId: string | number,
  userRole: string,
  actionMenuRights: UserRights,
  explicitlyDisabled?: boolean
): boolean => {
  if (explicitlyDisabled) return true;

  // Action-specific condition
  if (actionId === 'ExportTrueLawAI' && canExportToTrueLaw(actionMenuRights)) {
    return true;
  }

  return false;
};

interface SelectSubItem {
  id: string | number;
  name: string;
  disabled?: boolean;
  subItems?: SelectSubItem[];
  checked?: boolean;
}

type SourceDetails = {
  LstBulkActionContext: {ID: number; SourceTypeCode: SourceTypeCode}[];
};

const shortInfo = () => (
  <>
    <p data-testid={`view-saved-search-tt0`}>{t('savedSearch.toolTip.tt0')}</p>
    <br data-testid={`view-saved-search-br`} />
    <h3 data-testid={`view-saved-search-tt1`}>
      {t('savedSearch.toolTip.tt1')}
    </h3>
    <p data-testid={`view-saved-search-tt2`}>{t('savedSearch.toolTip.tt2')}</p>
    <br data-testid={`view-saved-search-br-btn`} />
    <h3 data-testid={`view-saved-search-tt3`}>
      {t('savedSearch.toolTip.tt3')}
    </h3>
    <p data-testid={`view-saved-search-tt4`}>{t('savedSearch.toolTip.tt4')}</p>
    <br data-testid={`view-saved-search-br-button`} />
    <h3 data-testid={`view-saved-search-tt5`}>
      {t('savedSearch.toolTip.tt5')}
    </h3>
    <p data-testid={`view-saved-search-tt6`}>{t('savedSearch.toolTip.tt6')}</p>
    <br data-testid={`view-saved-search-br-icon`} />
    <h3 data-testid={`view-saved-search-tt7`}>
      {t('savedSearch.toolTip.tt7')}
    </h3>
    <p data-testid={`view-saved-search-tt8`}>{t('savedSearch.toolTip.tt8')}</p>
    <p data-testid={`view-saved-search-tt9`}>{t('savedSearch.toolTip.tt9')}</p>
  </>
);

const ViewSavedSearch = () => {
  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [selectedItemData, setSelectedItemData] =
    useState<TreeViewBaseItem<ExtendedTreeItemProps> | null>(null);
  const [isTrueLawOpen, setIsTrueLawOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<ISavedSearchResponse | null>(
    null
  );
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastStatus, setToastStatus] = useState<ToastType>(ToastType.Success);
  const [documentCount, setDocumentCount] = useState<number>(0);
  const [docLimitSourceTypeCode, setDocLimitSourceTypeCode] =
    useState<SourceTypeCode>(SourceTypeCode.DOCVIEW);
  const [showDocLimitWarning, setShowDocLimitWarning] = useState(false);
  const [selectedActionId, setSelectedActionId] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [called, setCalled] = useState(false);
  const [groupSeachIds, setGroupSeachIds] = useState<string[]>([]);
  const [savedSearchList, setSavedSearchList] = useState<
    ISavedSearchResponse[]
  >([]);
  const [nestedChildModal, setNestedChildModal] = useState(false);
  const [openExecuteModal, setOpenExecuteModal] = useState(false);
  const [openNestedGrandChildSearchModal, setOpenNestedGrandChildSearchModal] =
    useState(false);
  const [sharedSavedGroupDisabled, setSharedSavedGroupDisabled] =
    useState<boolean>(false);
  const hasRunSearchRef = useRef<boolean>(false);
  const refetchList = useRef<boolean>(false);
  const triggerToast = (message: string, status: ToastType) => {
    setToastMessage(message);
    setToastStatus(status);
    setShowToast(true);
  };
  const [rows, setRows] = useState<NestedSearchResponse[]>([]);
  const [savedsearchIds, setSavedSearchIds] = useState<number[]>([]);
  const {
    data: competedSavedSearchIdData,
    refetch: refetchGetIsCompletedSavedSearchIdData,
  } = useGetCompletedSavedSearchId(called, Number(selectedItem));

  const {refetch, isFetching} = useGetSearchCount(Number(selectedItem));

  const {mutate: runBackgroundSearchQueue} = useRunBackgroundSearchQueue();
  const {mutate: resolvedNestedSaved, isPending: isNestedSearchLoading} =
    useResolveNestedSavedSearch();

  const lastEvent = useSelector((state: RootState) => state.signalr.lastEvent);

  //refectch saved search based on the notification status
  useEffect(() => {
    if (
      lastEvent?.payload.type === 'SaveSearchSuccess' ||
      lastEvent?.payload.type === 'SaveSearchErrorEvent'
    ) {
      if (
        savedsearchIds.includes(lastEvent?.payload?.payload?.searchId) ||
        savedsearchIds.includes(lastEvent?.payload.payload?.saveSearchID)
      ) {
        refetchList.current = true;
      }
    }
  }, [lastEvent?.payload.type]);

  const dispatch = useDispatch();

  const navigateToDocPage = (masterId: number) => {
    // include ConceptParameters needed for concept hit counts.
    dispatch(
      storeSourceTypeCode(
        selectedActionId === 'ViewInDocList'
          ? docLimitSourceTypeCode
          : SourceTypeCode.SAVEDSEARCH
      )
    );

    if (selectedActionId == 'ViewInDocView') {
      dispatch(storeDocumentListMasterId(String(masterId)));

      navigate('/DocumentViewer/DocView');
    } else if (selectedActionId == 'ViewInDocViewInNewTab') {
      dispatch(storeDocumentListMasterId(String(masterId)));

      const newWindow = window.open('about:blank', '_blank');
      newWindow &&
        (newWindow.location.href = `${window.location.origin}/DocumentViewer/DocView`);
    } else if (selectedActionId == 'ViewInDocList') {
      dispatch(setDocListId(masterId));
      const backPath = `${window.location.pathname}${window.location.search}`;
      dispatch(
        setDocListBackNavigation({
          label: t('savedSearch.title'),
          path: backPath,
        })
      );
      navigate('/Document/DocList');
    }
  };
  useEffect(() => {
    if (competedSavedSearchIdData && called) {
      setDocumentCount(competedSavedSearchIdData?.uniqueCount || 0);
      setCalled(false);
      if (
        Number(competedSavedSearchIdData?.uniqueCount) === 0 ||
        competedSavedSearchIdData?.uniqueCount === ''
      ) {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      setGroupSeachIds(competedSavedSearchIdData?.searchIds || []);
      setTimeout(() => setShowDocLimitWarning(true), 2000);
    }
  }, [competedSavedSearchIdData, called]);

  const [sourceDetails, setSourceDetails] = useState<SourceDetails>();

  const loginUserData = useSelector(
    (state: RootState) => state.authenticatedUser.user
  );
  const navigate = useNavigate();

  const {mutate: getNavigationMasterListId} = useGetNavigationMasterListId();

  const redirectReportMutation = useRedirectReport((data) => {
    const redirectResponse =
      data?.selectedSearchID?.map((id) => String(id)) ?? [];
    if (redirectResponse.length === 0) {
      triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
      return;
    }
    navigate('/DataAnalysisReport/term/view', {
      state: {redirectResponse},
    });
  });

  const actionMenu = useSelector(
    (state: RootState) => state.actionmenu.userRights
  );

  const filteredActions = (() => {
    if (!loginUserData) return [];
    const userRole = String(
      loginUserData.roleId ?? loginUserData.baseRoleId ?? ''
    );
    const mapAndFilter = (items: DocActionMenuItem[]): SelectSubItem[] =>
      items
        .filter((it) => !it.Roles || it.Roles.includes(userRole))
        .map((it) => ({
          id: it.id,
          name: t(`savedSearch.actionMenu.items.${it.name}`),
          disabled: isActionDisabled(it.id, userRole, actionMenu, it.disabled),
          subItems: it.subItems ? mapAndFilter(it.subItems) : undefined,
        }));
    return mapAndFilter(SAVED_SEARCH_ACTION_MENU);
  })();

  const convertToCustomMenuItems = (
    items: SelectSubItem[]
  ): CustomMenuItem[] => {
    return items.map((item) => {
      const isExportTrueLaw = item.id === 'ExportTrueLawAI';
      return {
        id: item.id.toString(),
        label: isExportTrueLaw ? (
          <Box className="export-truelaw-label">
            <TrueLawAIIcon className="icon-size" />
            {item.name}
          </Box>
        ) : (
          item.name
        ),
        disabled: item.disabled,
        checked: item.checked,
        submenu: item.subItems
          ? convertToCustomMenuItems(item.subItems)
          : undefined,
      };
    });
  };

  const getSelectedTreeItem = (itemId: string) => {
    setSelectedRow(null);
    setSelectedItem(itemId);
    setSourceDetails(undefined);
  };

  const getSelectedTreeItemData = (
    item: TreeViewBaseItem<ExtendedTreeItemProps>
  ) => {
    setSelectedItemData(item);
    if (
      item?.text?.includes(t('savedSearch.sharedGroup.sharedWith')) ||
      item?.text?.includes(t('savedSearch.sharedGroup.preBuildModel')) ||
      item?.text?.includes(t('savedSearch.sharedGroup.sharedWithProject'))
    ) {
      setSharedSavedGroupDisabled(true);
    } else {
      setSharedSavedGroupDisabled(false);
    }
  };

  const onActionSelect = (action: SelectSubItem | null | CustomMenuItem) => {
    if (!action) return;
    const actionId = action.id?.toString();
    if (actionId === 'ViewInDocList') {
      if (Number(selectedRow?.result) === 0 || selectedRow?.result === '') {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      if (selectedRow) {
        setShowDocLimitWarning(true);
      } else {
        setCalled(true);
      }
      setDocLimitSourceTypeCode(SourceTypeCode.DOCLIST);
      setSelectedActionId('ViewInDocList');
    }

    if (actionId === 'TallyReport') {
      if (!selectedRow) {
        return;
      }
      if (selectedRow.status.toUpperCase() !== 'COMPLETED') {
        triggerToast(t('savedSearch.tallyWarning'), ToastType.Warning);
        return;
      }
      const sourceInfo = {
        sourceDetails: [
          {
            sourceID: selectedRow.searchID.toString(),
          },
        ],
        sourceTypeCode: 'SAVEDSEARCH',
        destinationContextTypeCode: 'TALLY',
        totalDocumentToView: -1,
      };
      getNavigationMasterListId(
        {sourceInfo},
        {
          onSuccess: (data) => {
            navigate('/Report/Tally', {
              state: {
                navigationSourceType: 'SEARCH',
                source: [String(data.reportMasterDoclistId ?? '')],
                sourceName: 'SEARCHES',
                savedSearchName: selectedRow?.searchName ?? '',
              },
            });
          },
          onError: () => {
            triggerToast(
              t('savedSearch.getReportMasterDocListErr'),
              ToastType.Error
            );
          },
        }
      );
    }

    if (actionId === 'SearchTermReport') {
      const selectedSearchID = selectedItem ? String(selectedItem) : '';
      if (!selectedSearchID) {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      if (!selectedRow && savedSearchList.length === 0) {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      if (
        selectedRow &&
        (Number(selectedRow?.result) === 0 || selectedRow?.result === '')
      ) {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      const payload = selectedRow
        ? {
            selectedSearchID,
            saveSearchID: selectedRow.searchID.toString(),
          }
        : {
            selectedSearchID,
          };
      redirectReportMutation.mutate(payload);
    }
    if (actionId === 'ViewInDocView' || actionId === 'ViewInDocViewInNewTab') {
      if (Number(selectedRow?.result) === 0 || selectedRow?.result === '') {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      setDocLimitSourceTypeCode(SourceTypeCode.DOCVIEW);
      setSelectedActionId(actionId);
      if (selectedRow) {
        setDocumentCount(selectedRow.result ? Number(selectedRow.result) : 0);
        setShowDocLimitWarning(true);
      } else {
        setCalled(true);
      }
    }

    if (actionId === 'ExportData') {
      setDocLimitSourceTypeCode(SourceTypeCode.EXPORTDATA);
      setSelectedActionId(actionId);
      if (selectedRow) {
        if (selectedRow?.status.toUpperCase() !== 'COMPLETED') {
          triggerToast(t('savedSearch.tallyWarning'), ToastType.Warning);
          return;
        }
        navigate('/Report/ExportData', {
          state: {
            item: {
              navigationSourceType: SourceTypeCode.SAVEDSEARCH,
              source: [selectedRow?.searchID.toString()],
              sourceName: SourceTypeCode.SEARCH,
              sourceDisable: true,
            },
          },
        });
      } else {
        const totalCount =
          savedSearchList?.reduce(
            (sum, item) => sum + (Number(item?.result) ?? 0),
            0
          ) ?? 0;
        if (totalCount === 0) {
          triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        } else {
          const sourceSearch = (savedSearchList ?? [])
            .filter((list) => list.status?.toUpperCase() === 'COMPLETED')
            .map((list) => list.searchID);
          navigate('/Report/ExportData', {
            state: {
              item: {
                navigationSourceType: SourceTypeCode.SAVEDSEARCH,
                source: sourceSearch,
                sourceName: SourceTypeCode.SEARCH,
                sourceDisable: true,
              },
            },
          });
        }
      }
    }

    if (actionId === 'SeeConcepts') {
      const backPath = `${window.location.pathname}${window.location.search}`;
      if (selectedRow) {
        if (selectedRow.status !== 'COMPLETED') {
          triggerToast(t('savedSearch.statusNotCompleted'), ToastType.Warning);
          return;
        }
        if (!selectedRow.result || selectedRow.result === '0') {
          triggerToast(t('savedSearch.noDocsFound'), ToastType.Warning);
          return;
        }
        dispatch(
          setReportDetails({
            sourceId: selectedRow?.searchID.toString() ?? '0',
            sourceName: 'SEARCHES',
            backSourceLabel: t('savedSearch.title'),
            backSourcePath: backPath,
            navigationSourceType: 'search',
            sourceSelectionText: t('savedSearch.sourceSelectionText'),
          })
        );
        navigate('/DataAnalysisReport/ConceptExplorer');
      }
    }
    if (actionId == 'ExportTrueLawAI') {
      if (selectedRow && selectedRow.status?.toUpperCase() !== 'COMPLETED') {
        triggerToast(t('savedSearch.tallyWarning'), ToastType.Warning);
        return;
      }
      if (
        Number(selectedRow?.result) === 0 ||
        selectedRow?.result === '' ||
        !selectedRow
      ) {
        triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        return;
      }
      setIsTrueLawOpen(true);
    }
  };

  const handleActionClick = (item: CustomMenuItem) => {
    const findOriginalItem = (
      items: SelectSubItem[],
      id: string
    ): SelectSubItem | null => {
      for (const item of items) {
        if (item.id.toString() === id) {
          return item;
        }
        if (item.subItems) {
          const found = findOriginalItem(item.subItems, id);
          if (found) return found;
        }
      }
      return null;
    };

    const originalItem = findOriginalItem(filteredActions, item.id);
    if (originalItem && onActionSelect) {
      onActionSelect(originalItem);
    }
  };

  const handleSavedSearchSelect = (row: ISavedSearchResponse) => {
    setSelectedRow(row);
    setSavedSearchIds([row?.searchID]);
    setDocumentCount(row.result ? Number(row.result) : 0);
    setSharedSavedGroupDisabled(false);
  };

  const handleWarningCancel = () => {
    setShowDocLimitWarning(false);
    setSelectedActionId('');
  };

  const {mutate: fetchDocumentList} = useDocumentList();

  const {mutate: fetchDocumentViewerListId} = useDocumentViewerListId();

  const callNavigationMasterListAPI = (count: number) => {
    const idsToSend =
      groupSeachIds.length > 0
        ? groupSeachIds
        : selectedRow
          ? [Number(selectedRow?.searchID)]
          : [];
    const payload = {
      sourceInfo: {
        sourceDetails: idsToSend.map((id) => ({
          sourceID: Number(id),
          sourceTypeCode: SourceTypeCode.SAVEDSEARCH,
        })),
        sourceTypeCode: SourceTypeContextCode.SAVEDSEARCH,
        destinationContextTypeCode: docLimitSourceTypeCode,
        totalDocumentToView: count,
      },
    };
    const payloadDocumentViewer = {
      objSource: {
        sourceDetails: idsToSend.map((id) => ({
          sourceID: Number(id),
        })),
        sourceTypeCode: SourceTypeContextCode.SAVEDSEARCH,
        destinationContextTypeCode: docLimitSourceTypeCode,
        totalDocumentToView: count,
      },
    };
    if (selectedActionId === 'ViewInDocList') {
      fetchDocumentList(payload as any, {
        onSuccess: (response) => {
          const masterId = Number(response.docId) ?? 0;
          navigateToDocPage(masterId);
        },
        onError: (error) => {
          triggerToast(error.message, ToastType.Error);
          setIsLoading(false);
        },
      });
    } else if (
      selectedActionId === 'ViewInDocViewInNewTab' ||
      selectedActionId === 'ViewInDocView'
    ) {
      fetchDocumentViewerListId(payloadDocumentViewer as any, {
        onSuccess: (response) => {
          const masterId =
            Number(response?.documentListID) ??
            Number(response?.defaultMasterID) ??
            0;
          navigateToDocPage(masterId);
        },
        onError: (error) => {
          triggerToast(error.message, ToastType.Error);
          setIsLoading(false);
        },
      });
    }
  };
  const onContinueDocLimit = (count: number) => {
    setShowDocLimitWarning(false);
    switch (docLimitSourceTypeCode) {
      case SourceTypeCode.DOCVIEW: {
        callNavigationMasterListAPI(count);
        break;
      }
      case SourceTypeCode.DOCLIST: {
        callNavigationMasterListAPI(count);
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSavedSearchAll = (rows: ISavedSearchResponse[]) => {
    setSavedSearchList(rows);
    const searchId = rows?.map((item) => item?.searchID);
    setSavedSearchIds(searchId);
  };

  const handleGetSourceDetails = async (
    sourceData: {
      [key: string]: any;
    },
    forAPIEvent?: string,
    forAction?: ReportActionMenuOptionTypes | string | null
  ) => {
    let LstBulkActionContext;
    if (selectedRow === null) {
      const response = await refetchGetIsCompletedSavedSearchIdData();
      const searchIds = response.data?.searchIds ?? [];

      if (searchIds.length === 0) {
        triggerToast(t('savedSearch.noDocsFound'), ToastType.Warning);
        if (forAction === ReportActionMenuOptionTypes.BulkAssign) {
          setSourceDetails(undefined);
        }
        return Promise.reject(new Error('Error'));
      }

      LstBulkActionContext = searchIds.map((id: string) => ({
        ID: Number(id),
        SourceTypeCode: SourceTypeCode.SAVEDSEARCH,
      }));

      const updatedSourceDetails = {
        ...sourceData,
        LstBulkActionContext,
      };

      setSourceDetails(updatedSourceDetails);
      return Promise.resolve(updatedSourceDetails);
    }

    LstBulkActionContext = [
      {
        ID: selectedRow!.searchID,
        SourceTypeCode: SourceTypeCode.SAVEDSEARCH,
      },
    ];

    const updatedSourceDetails = {...sourceData, LstBulkActionContext};
    setSourceDetails(updatedSourceDetails);
    return Promise.resolve(updatedSourceDetails);
  };

  const leftPanel = () => (
    <Box className="search-treeview-container">
      <Box className="treeview-header">
        <Typography
          className="typo-text subhead4_size saved-search-title-text"
          data-testid={`view-saved-search-group-title`}
        >
          {t('savedSearch.groupTitle')}
        </Typography>
      </Box>
      {/* Tree view component to be added here */}
      <Box>
        <SavedSearchTree
          getSelectedTreeItem={getSelectedTreeItem}
          getSelectedTreeItemData={getSelectedTreeItemData}
        />
      </Box>
    </Box>
  );

  const rightPanel = () => (
    <Box className="search-grid-container">
      <SavedSearchDataGrid
        selectedItem={selectedItem ?? ''}
        onRowSelect={handleSavedSearchSelect}
        handleSavedSearchAll={handleSavedSearchAll}
        refetchList={refetchList.current}
        setRefetchList={(value: boolean) => {
          refetchList.current = value;
        }}
      />
    </Box>
  );

  const handleRunSearch = async () => {
    if (!selectedItem) return;
    if (selectedRow?.status?.toUpperCase().replace(/\s/g, '') === 'INPROGRESS') {
      triggerToast(t('savedSearch.statusNotCompleted'), ToastType.Warning);
      return;
    }
    if (!selectedRow) {
      hasRunSearchRef.current = true;
      try {
        const {data} = await refetch();
        if (!hasRunSearchRef.current) return;
        if (data && data?.searchCount === 0) {
          triggerToast(t('savedSearch.noDocsAvailable'), ToastType.Warning);
        } else if (data && data?.searchCount > 0) {
          setOpenExecuteModal(true);
          hasRunSearchRef.current = false;
        }
      } catch (error) {
        console.error('Error fetching search count:', error);
        hasRunSearchRef.current = false;
      }
    } else {
      handleExecute();
    }
  };

  const handleExecute = () => {
    setOpenExecuteModal(false);
    handleProceed();
    // setNestedChildModal(false);
    //   setOpenNestedGrandChildSearchModal(true);
    //   setRows(mockNestedSearchData.data?.nestedSavedSearches)
    // const selectedSearchId =
    //   selectedRow?.searchID ??
    //   savedSearchList?.map((savedSavedItem) => savedSavedItem.searchID);
    // const payload = {
    //   resolveBy: 'SAVED_SEARCH_IDS',
    //   values: selectedSearchId,
    // };
    // resolvedNestedSaved(payload, {
    //   onSuccess: (result) => {
    // switch(result.nestedSavedSearchesCount){
    //   case 0:
    //      setNestedChildModal(true);
    //      break;
    //   case 1:
    //      setOpenNestedGrandChildSearchModal(true);
    //      break;
    // }
    //   },
    //   onError: () => {
    //     triggerToast(
    //       t('savedSearch.savedSearchTreeFlyout.moveError'), //check
    //       ToastType.Error
    //     );
    //   },
    // });
  };

  const handleProceed = () => {
    let payload: IRunBackgroundSearchQueueRequest = {
      searchGroupId: Number(selectedItem),
      searchsecuritygroupid: selectedItemData?.securitygroupsearchid || 0,
    };
    if (selectedRow) {
      payload = {
        ...payload,
        searchID: selectedRow.searchID,
      };
    }
    runBackgroundSearchQueue(payload, {
      onSuccess: (data) => {
        if (data.message?.toLowerCase().includes('already in progress')) {
          triggerToast(t('savedSearch.statusNotCompleted'), ToastType.Warning);
          return;
        }
        triggerToast(data.message, ToastType.Success);
        hasRunSearchRef.current = false;
        refetchList.current = true;
      },
      onError: (error: any) => {
        triggerToast(
          error?.response?.data?.message ||
            t('savedSearch.executeSearch.executeError'),
          ToastType.Error
        );
      },
    });
    setNestedChildModal(false);
    setOpenNestedGrandChildSearchModal(false);
  };

  return (
    <Box className="saved-search-main">
      <Box className="saved-search-header">
        <Box className="saved-search-title">
          <Typography
            className="typo-text headline3_size saved-search-title-text"
            data-testid={`view-saved-search-title`}
          >
            {t('savedSearch.title')}
          </Typography>
          <ArrTooltipWrapper
            title={t('savedSearch.title')}
            trigger={
              <InfoIcon fontSize="medium" className="saved-search-info-icon" />
            }
          >
            {shortInfo()}
          </ArrTooltipWrapper>
        </Box>
        <Box className="saved-button-container">
          <ArrButton
            aria-label={t('savedSearch.runSearch')}
            variant="primary"
            size="small"
            onClick={handleRunSearch}
            disabled={
              !(selectedItem || selectedRow) ||
              isFetching ||
              sharedSavedGroupDisabled
            }
            className="new-coding-form-button"
            dataTestId="run-search"
          >
            {t('savedSearch.runSearch')}
          </ArrButton>

          <ActionMenuWrapper
            dataTestId="view-saved-search-action-menu"
            sourceType={SourceTypeCode.SAVEDSEARCH}
            sourceTypeContext={SourceTypeContextCode.SAVEDSEARCHWC}
            actions={convertToCustomMenuItems(filteredActions)}
            onActionPick={(action) => {
              handleActionClick(action);
            }}
            additionalParameters={{
              documentCount: selectedRow?.result ?? '',
            }}
            size="small"
            getSourceDetails={(sourceData, event, actionType) => {
              if (actionType === 'BulkTag') {
                if (
                  selectedRow &&
                  selectedRow?.status.toUpperCase() !== 'COMPLETED'
                ) {
                  triggerToast(
                    t('savedSearch.tallyWarning'),
                    ToastType.Warning
                  );
                  setSourceDetails(undefined);
                  return Promise.reject(new Error('Error'));
                }
              } else if (
                actionType === ReportActionMenuOptionTypes.QuickBatch &&
                selectedRow?.result === ''
              ) {
                triggerToast(t('savedSearch.tallyWarning'), ToastType.Warning);
                setSourceDetails(undefined);
                return Promise.reject(new Error('Error'));
              }
              if (event === 'getBulkActionPopup') {
                return handleGetSourceDetails(sourceData, event, actionType);
              }
              if (event === 'getLikePopup' || event === 'getBulkDocListId') {
                setSourceDetails(undefined);
                return {...sourceDetails};
              }
              return sourceData;
            }}
          />
        </Box>
      </Box>
      <Box className="saved-search-container">
        <ArrSplitPanel leftPanel={leftPanel()} rightPanel={rightPanel()} />
      </Box>
      <ExportTrueLawModal
        open={isTrueLawOpen}
        selectedSavedSearch={selectedRow}
        onClose={() => setIsTrueLawOpen(false)}
      />
      {showToast && (
        <ArrToastNotification
          data-testid="tag-toast"
          message={toastMessage}
          onClose={() => {
            setToastMessage('');
            setShowToast(false);
          }}
          status={[toastStatus]}
        />
      )}
      {showDocLimitWarning && (
        <ArrDocMaxLimitWarning
          totalDocumentCount={documentCount}
          show={showDocLimitWarning}
          destination={docLimitSourceTypeCode}
          onCancel={handleWarningCancel}
          onContinue={onContinueDocLimit}
        />
      )}
      {(isLoading || isNestedSearchLoading) && (
        <ArrLoadingSpinner
          overlay
          isOpen={isLoading || isNestedSearchLoading}
        />
      )}
      <ArrModal
        showModal={openExecuteModal}
        onClose={() => {
          setOpenExecuteModal(false);
        }}
        className="saved-search-execute-modal"
        title={t('savedSearch.executeSearch.title')}
        description={t('savedSearch.executeSearch.description')}
        ariaLabel={t('savedSearch.executeSearch.title')}
        ariaDescription={t('savedSearch.executeSearch.description')}
        dataTestId="saved-search-execute-modal"
        buttons={[
          {
            id: '1',
            label: t('common.cancel'),
            onClick: () => {
              setOpenExecuteModal(false);
            },
            variant: 'secondary',
            dataTestId: 'sse-cancel-btn',
          },
          {
            id: '2',
            label: t('common.continue'),
            onClick: () => handleExecute(),
            variant: 'primary',
            dataTestId: 'sse-save-btn',
          },
        ]}
      ></ArrModal>
      <ArrModal
        showModal={nestedChildModal}
        onClose={() => setNestedChildModal(false)}
        showClose
        title={t('savedSearch.nestedSearchModal.title')}
        description={t('savedSearch.nestedSearchModal.description')}
        titleStartIcon={
          <InfoIcon
            className="info-icon nested-modal-title-icon"
            aria-label="Information"
          />
        }
        dataTestId="savedsearch-nestedmodal"
        buttons={[
          {
            id: '1',
            label: t('savedSearch.nestedSearchModal.cancelButton'),
            dataTestId: 'ssn-cancel-button',
            onClick: () => {
              setNestedChildModal(false);
            },
            variant: 'secondary',
          },
          {
            id: '2',
            label: t('savedSearch.nestedSearchModal.proceedButton'),
            dataTestId: 'ssn-proceed-button',
            onClick: () => {
              handleProceed();
            },
            variant: 'primary',
          },
        ]}
      ></ArrModal>
      <ArrModal
        showModal={openNestedGrandChildSearchModal}
        onClose={() => {
          setOpenNestedGrandChildSearchModal(false);
        }}
        className={`nested-search-execute-modal`}
        title={t('savedSearch.executeNestedSearch.title')}
        ariaLabel={t('savedSearch.executeNestedSearch.title')}
        ariaDescription={t('savedSearch.executeNestedSearch.description')}
        dataTestId="nested-search-execute-modal"
      >
        <Box>
          <ArrBanner
            type="contextual"
            variant="complete"
            bannerContent={t(
              'savedSearch.executeNestedSearch.nestedInfoContent'
            )}
            startIcon={<CompleteIcon />}
            dataTestId="saved-search-banner"
          />
          <div
            className="text-description-container"
            data-testid={`view-saved-search-nested-modal-content`}
          >
            <Typography
              className="typo-text body3_size modal-description"
              data-testid="nested-search-modal-text"
            >
              {t('savedSearch.executeNestedSearch.nestedModalContent')}
            </Typography>
          </div>
          <Box className="nested-child-grid" data-testid="nested-child-table">
            <ArrDataGrid
              rowHeight={DEFAULT_ROW_HEIGHT}
              rows={rows}
              columns={nestedColumns}
              primaryKey="ID"
              className="nested-table-grid"
              getRowId={(rows) => rows.id}
            />
          </Box>
          <Box className="nested-modal-action-buttons">
            <ArrButton
              onClick={() => {
                setOpenNestedGrandChildSearchModal(false);
              }}
              variant="secondary"
              dataTestId="cancel-btn"
              aria-label={t('common.cancel')}
              className="modal-action-button"
            >
              {t('common.cancel')}
            </ArrButton>
            <Box className="nested-modal-button">
              <ArrButton
                aria-label={t('common.export')}
                variant="secondary"
                onClick={() => {}}
                className="modal-action-button"
                dataTestId="export-btn"
              >
                <div
                  className="button-content"
                  data-testid={`view-saved-search-export`}
                >
                  <ExportIcon />
                  {t('common.export')}
                </div>
              </ArrButton>

              <ArrButton
                onClick={() => handleProceed()}
                variant="primary"
                dataTestId="proceed-btn"
                type="submit"
                aria-label={t('common.proceed')}
                className="modal-action-button"
              >
                {t('common.proceed')}
              </ArrButton>
            </Box>
          </Box>
        </Box>
      </ArrModal>
    </Box>
  );
};

export default ViewSavedSearch;
